import styled, { keyframes } from 'styled-components';

const checkmarkAnim = keyframes`
  0% { background-position-y: 5px; }
  50% { background-position-y: -2px; }
  100% { background-position-y: 0; }
`;

export const PrsLabelText = styled.span`
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.875rem;
  line-height: 1.375rem;
`;

export const PrsLabel = styled.div`
  color: var(--prs-c-gray-600);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  user-select: none;
`;

export const PrsLabelError = styled.span`
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.875rem;
  line-height: 1.375rem;
  color: var(--prs-c-danger-600);
`;

export const PrsFormControl = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-self: stretch;

  > ${PrsLabelError} {
    display: ${({ $error }) => ($error ? 'inherit' : 'none')};
  }
`;

export const PrsInput = styled.input`
  appearance: none;
  padding: 0.1875rem 1rem;
  border: 1px solid ${({ $error }) => ($error ? 'var(--prs-c-danger)' : 'var(--prs-c-gray)')};
  width: 100%;
  min-height: 2rem;
  background: ${({ $error }) => ($error ? 'var(--prs-c-danger-100)' : 'var(--prs-c-white)')};
  color: var(--prs-c-gray-900);
  text-align: left;
  font-weight: var(--prs-fw-ui-md);
  font-size: var(--prs-fz-ui-md);
  line-height: var(--prs-fl-ui-md);
  flex-shrink: 1;
  display: block;
  border-radius: var(--prs-radius-input);
  transition-property: var(--prs-transition-property);
  transition-timing-function: var(--prs-transition-timing);
  transition-duration: var(--prs-transition-duration);
  box-sizing: border-box;

  &::placeholder {
    color: var(--prs-c-gray-600);
    font-style: italic;
  }

  &:focus {
    outline: 2px solid var(--prs-c-primary);
    outline-offset: 1px;
  }

  &:disabled {
    border-color: var(--prs-c-gray);
    color: var(--prs-c-gray-600);
    background-color: var(--prs-c-gray-200);
    cursor: not-allowed;
  }

  &:disabled::placeholder {
    color: var(--prs-c-gray-400);
  }
`;

export const PrsCheckbox = styled.input.attrs({ type: 'checkbox' })`
  --chk-bg: var(--prs-c-primary);
  --chk-fg: var(--prs-c-white);
  --chk-size: 1rem;
  appearance: none;
  border: 1px solid currentColor;
  width: var(--chk-size);
  height: var(--chk-size);
  background-color: var(--prs-c-white);
  color: var(--prs-c-gray-600);
  flex-shrink: 0;
  cursor: pointer;
  border-radius: var(--prs-radius-btn);

  &:checked,
  &[aria-checked='true'] {
    background-color: var(--chk-bg);
    background-image:
      linear-gradient(-45deg, transparent 65%, var(--chk-bg) 65.99%),
      linear-gradient(45deg, transparent 75%, var(--chk-bg) 75.99%),
      linear-gradient(-45deg, var(--chk-bg) 40%, transparent 40.99%),
      linear-gradient(45deg, var(--chk-bg) 30%, var(--chk-fg) 30.99%, var(--chk-fg) 40%, transparent 40.99%),
      linear-gradient(-45deg, var(--chk-fg) 50%, var(--chk-bg) 50.99%);
    background-repeat: no-repeat;
    animation: ${checkmarkAnim} 0.2s ease-out;
  }

  &:indeterminate,
  &.prs-checkbox_indeterminate {
    background-color: var(--chk-fg);
    background-image:
      linear-gradient(90deg, transparent 80%, var(--chk-bg) 80%),
      linear-gradient(-90deg, transparent 80%, var(--chk-bg) 80%),
      linear-gradient(0deg, var(--chk-bg) 43%, var(--chk-fg) 43%, var(--chk-fg) 57%, var(--chk-bg) 57%);
    background-repeat: no-repeat;
    animation: ${checkmarkAnim} 0.2s ease-out;
  }

  &:focus-visible,
  &.prs-checkbox_focus {
    outline: 2px solid var(--prs-c-primary);
    outline-offset: 1px;
  }

  &:disabled {
    --chk-bg: var(--prs-c-gray-100);
    --chk-fg: currentColor;
    background-color: var(--prs-c-gray-100);
    color: var(--prs-c-gray-300);
    cursor: not-allowed;
  }

  &.prs-checkbox-lg {
    --chk-size: 1.5rem;
  }

  &.prs-checkbox-xl {
    --chk-size: 2rem;
  }
`;
